export enum RTFVersion {
    // FB_OLD              = 1, // DraftJS rtf has no version
    LEXICAL             = 'lexical-1',

    CLICKUP_IMPORT      = 'clickup_import',
}


export type ContentRTF = {
    v                           : RTFVersion
    content?                    : any,
    importOriginal?             : string   // original content when import - we never change it !
    // markdown                    : any,  poka ne nado - potom nado !!!!
}